import useSWR from 'swr';
import { createRestApiClient } from '..';
import {
  getBrowserId,
  getScreenName,
  getUserIsLoggedIn,
  getUserToken,
} from '../../Utils/helper';
import Cookies from 'js-cookie';
import { getWebUserType } from '../../Utils/getWebUserType';
import { fireEvent } from '../../Utils/fireEvent';

export const productFetcher = async (url) => {
  const restApiClient = createRestApiClient();
  let params = {
    'language': 'en',
    'Mylo-In-App': 'false',
  };
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,
      params: params,
      headers: { 'Mylo-In-App': false },
    })
    .then((res) => res.data);
  return data;
};

export const reviewFetcher = (id, pdp, skipReviews = null, sort = null) => {
  const restApiClient = createRestApiClient();
  let urlParams = null;
  if (typeof window !== 'undefined') {
    urlParams = new URLSearchParams(window.location.search);
  }

  const url = `api/getContentDetails`;
  let params = {
    content_type: 1,
    for_pdp: pdp ? true : false,
    product_id: id,
    relevance: urlParams?.get('relevance')
      ? JSON.parse(urlParams?.get('relevance'))
      : null,
    term_id: Cookies.get('zone_term_id')
      ? parseInt(Cookies.get('zone_term_id'))
      : 0,
  };
  if (skipReviews != null) {
    params['skip'] = skipReviews;
    params['limit'] = 10;
  }
  if (sort) {
    params['sort'] = sort;
  }
  let data = restApiClient
    .request({
      method: 'POST',
      url: url,
      data: params,
      headers: { 'Mylo-In-App': false, 'authorization': getUserToken() },
    })
    .then((res) => res.data);
  return data;
};

export const clinicReviewFetcher = (body) => {
  const restApiClient = createRestApiClient();
  const url = `api/getContentDetails`;
  const params = { userType: 'A' };

  let data = restApiClient
    .request({
      method: 'POST',
      url: url,
      params: params,
      data: body,
      headers: { 'Mylo-In-App': false, 'authorization': getUserToken() },
    })
    .then((res) => res.data);
  return data;
};

export const discussionFetcher = (id, pdp) => {
  const restApiClient = createRestApiClient();
  const params = {
    content_type: 2,
    for_pdp: pdp ? true : false,
    product_id: id,
  };
  const url = `api/getContentDetails`;

  return restApiClient
    .request({
      method: 'POST',
      url: url,
      data: params,
      headers: { 'Mylo-In-App': false },
    })
    .then((res) => res.data);
};

export const clinicDiscussionFetcher = (body) => {
  const restApiClient = createRestApiClient();
  const url = `api/getContentDetails`;

  return restApiClient
    .request({
      method: 'POST',
      url: url,
      data: body,
      headers: { 'Mylo-In-App': false },
    })
    .then((res) => res.data);
};

export const recentlyViewedFetcher = (id) => {
  const restApiClient = createRestApiClient();
  const url = `api/recently_viewed?product=${id}`;
  return restApiClient
    .request({
      method: 'GET',
      url: url,
    })
    .then((res) => res.data);
};
export const addToCartFetcher = (params) => {
  const restApiClient = createRestApiClient();

  const url = `api/AddToCart`;
  return restApiClient
    .request({
      method: 'POST',
      url: url,
      data: params,
      headers: {
        authorization: getUserToken(),
      },
    })
    .then((res) => res.data);
};
export function useGetProductData(initialData, productId) {
  const options = {
    fallbackData: initialData,
    revalidateOnMount: false,
    revalidateOnFocus: false,
    revalidateIfStale: false,
    revalidateOnReconnect: false,
  };
  if (!initialData) {
    delete options.initialData;
  }
  const { data, error, mutate } = useSWR(
    `api/getProduct/${productId}`,
    productFetcher,
    options,
  );
  return {
    updatedProductData: data,
    updatedProductLoading: !error && !data,
    updatedProductError: error,
    productMutate: mutate,
  };
}
export function useGetReviewData(initialData, ProductId) {
  const options = {
    fallbackData: initialData,
    revalidateOnMount: false,
    revalidateOnFocus: false,
  };
  if (!initialData) {
    delete options.initialData;
  }
  const { data, error, mutate } = useSWR(
    `api/getreviewDetails`,
    () => reviewFetcher(ProductId, true),
    options,
  );
  return {
    updatedReviewData: data?.data,
    updatedReviewLoading: !error && !data,
    updatedReviewError: error,
    reviewMutate: mutate,
  };
}
export function useGetDiscussionData(initialData, discussionId) {
  const options = {
    fallbackData: initialData,
    revalidateOnMount: false,
  };
  if (!initialData) {
    delete options.initialData;
  }
  const { data, error } = useSWR(
    `api/getdiscussionDetails`,
    () => discussionFetcher(discussionId),
    options,
  );
  return {
    discussionData: data,
    discussionLoading: !error && !data,
    discussionError: error,
  };
}
// export function useOfferData(offerList, productId) {
//     const options = {
//         fallbackData: offerList,
//         revalidateOnMount: false,
//         revalidateOnFocus: false,
//     };

//     const { data, mutate } = useSWR(`api/offerList`, () => {}, options);
//     return { data, offerMutate: mutate };
// }
//staging-api.myloapp.in//api/gullackInfoReact
export const postGullackInfoReact = async (params) => {
  const restApiClient = createRestApiClient();
  const url = `api/gullackInfoReact`;
  const data = await restApiClient
    .request({
      method: 'POST',
      url: url,
      data: params,
      headers: {
        authorization: getUserToken(),
      },
    })
    .then((res) => res.data);
  return data;
};

export const checkUserOrdered = async (id) => {
  const restApiClient = createRestApiClient();
  const url = `api/checkUserOrdered?product=${id}`;
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,
      headers: {
        authorization: getUserToken(),
      },
    })
    .then((res) => res.data);
  return data;
};
export const postBrowserEvent = async (params) => {
  const restApiClient = createRestApiClient();
  const url = `api/browserEvent`;
  const postData = {
    ...params,
    browser_id: `browser_id: ${getBrowserId()}`,
    datetime: `datetime: ${new Date().toISOString()}`,
  };
  const data = await restApiClient
    .request({
      method: 'POST',
      url: url,
      data: postData,
      headers: {
        authorization: getUserToken(),
      },
    })
    .then((res) => res.data);
  return data;
};

export const getAllProductIDs = (type = '') => {
  const restApiClient = createRestApiClient();
  const url = `api/products`;
  let params = {};
  if (type) {
    params = {
      type: type,
    };
  }
  return restApiClient
    .request({
      method: 'GET',
      url: url,
      params: params,
    })
    .then((res) => res.data);
};

export const productPriceFetcher = async (apiParams) => {
  const restApiClient = createRestApiClient();
  let params = {
    language: 'en',
    inApp: 'false',
    ...apiParams,
  };
  const data = await restApiClient
    .request({
      method: 'GET',
      url: 'api/new/getProductData',
      params: params,
      headers: { 'Mylo-In-App': false },
    })
    .then((res) => res.data)
    .catch((err) => {
      return { data: {}, error: true };
    });
  return data;
};
export const getMultipleProducts = async (apiParams) => {
  const restApiClient = createRestApiClient();
  const data = await restApiClient
    .request({
      method: 'GET',
      url: 'api/new/getMultipleProductsData',
      params: apiParams,
      headers: { 'Mylo-In-App': false },
      maxBodyLength: Infinity,
    })
    .then((res) => res.data)
    .catch((err) => {
      return { data: [], error: err };
    });
  return data;
};

export const getAllOffers = (product_ids, fromCart, type) => {
  const restApiClient = createRestApiClient();
  const url = `api/offers`;
  if (fromCart && !getUserIsLoggedIn()) {
    const productIdArr = product_ids?.split(',');
    for (let i = 0; i < productIdArr?.length; i++) {
      if (isNaN(productIdArr[i]) || productIdArr[i] === '') {
        fireEvent({
          category: 'offer_api_fail',
          screen_name: getScreenName(),
          support_variable: JSON.stringify({
            current_value: productIdArr[i],
          }),
          support_variable2: JSON.stringify({
            cookie_value: product_ids,
          }),
        });
        return { data: [] };
      }
    }
  }
  if (!getUserIsLoggedIn())
    product_ids = decodeURIComponent(product_ids)?.replace(/\s/g, '');
  return restApiClient
    .request({
      method: 'GET',
      url: url,
      params: {
        inApp: 0,
        product_ids: product_ids,
        type,
        userType: getWebUserType(),
      },
      headers: {
        authorization: getUserToken(),
      },
    })
    .then((res) => res.data);
};
export const getEDD = (pincode) => {
  const restApiClient = createRestApiClient();
  const url = `api/getEddOnPdp?zip_code=${pincode}`;
  return restApiClient
    .request({
      method: 'GET',
      url: url,
      headers: {
        authorization: getUserToken(),
      },
    })
    .then((res) => res.data);
};
export const getSimilarProducts = async (id) => {
  const restApiClient = createRestApiClient();
  const url = `api/getSimilarContent/${id}`;
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,
      headers: {
        authorization: getUserToken(),
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      return { data: {}, error: true };
    });
  return data;
};

export const getUserLocationData = async () => {
  const restApiClient = createRestApiClient();
  const url = `api/getUserLocation`;
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,
      headers: { 'Mylo-In-App': false },
    })
    .then((res) => res?.data?.data);
  return data;
};

export const saveFormData = async (formData) => {
  const restApiClient = createRestApiClient();
  const url = 'api/forms';
  const data = await restApiClient
    .request({
      method: 'POST',
      url: url,
      data: formData,
      headers: {
        authorization: getUserToken(),
      },
    })
    .then((res) => res.data);
  return data;
};

export const checkProductSddNddEligiblity = async (body) => {
  const restApiClient = createRestApiClient();
  const url = 'api/getProductEligiblityForNddSddOrder';
  const data = await restApiClient
    .request({
      method: 'POST',
      url: url,
      data: body,
      headers: {
        'Mylo-In-App': false,
        'authorization': getUserToken(true),
      },
    })
    .then((res) => res?.data)
    .catch((err) => {
      return { data: {}, error: true };
    });
  return data;
};

export const addReviewRating = async (params, body) => {
  const restApiClient = createRestApiClient();
  const url = `/api/addEditProductRating`;
  const data = await restApiClient
    .request({
      method: 'POST',
      url,
      params: params,
      data: body,
      headers: {
        'authorization': getUserToken(true),
        'Mylo-In-App': false,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      return null;
    });

  return data;
};

export const logUserEventData = async (eventName, userData) => {
  const restApiClient = createRestApiClient();
  const data = await restApiClient
    .request({
      method: 'POST',
      url: '/api/logUserEventData',
      headers: {
        authorization: getUserToken(),
      },
      params: { eventName: eventName, platform: 'web' },
      data: { eventData: userData },
    })
    .then((res) => res.data?.data);
  return data;
};
